<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ "add" }}</v-icon> {{ "Detalle comsión" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- <v-flex xs4 >
								<p><strong>CITE de la comisión:</strong></p>
							</v-flex> -->
              <v-flex xs12 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>CITE de la comisión:</strong> {{ this.form.cite }}
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <strong>Objetivo de la comisión:</strong>
                  <p>{{ this.form.objetivo }}</p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Fecha salida (viaje):</strong>
                    {{
                      this.form.fecha_salida
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                    <v-icon>date_range</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Fecha retorno (viaje):</strong>
                    {{
                      this.form.fecha_retorno
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                    <v-icon>date_range</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora salida (viaje):</strong>
                    {{ this.form.hora_salida }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora retorno (viaje):</strong>
                    {{ this.form.hora_retorno }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora salida tolerancia:</strong>
                    {{ this.form.hora_salida_tolera }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>

              <v-flex xs6 align-self-center="true">
                <v-card elevation="3" color="#E8EAEA">
                  <p>
                    <strong>Hora retorno tolerancia:</strong>
                    {{ this.form.hora_retorno_tolera }}
                    <v-icon>schedule</v-icon>
                  </p>
                </v-card>
              </v-flex>
            </v-layout>
            <small
              >* El sistema otorga dos horas de tolerancia antes y despues de
              los horarios del viaje</small
            >
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="close()"> <v-icon>cancel</v-icon>Cerrar </v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            <v-icon dark>check</v-icon> REGISTRAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {
        cite: "",
        objetivo: "",
        fecha_salida: "",
        fecha_retorno: "",
        hora_salida: "",
        hora_retorno: "",
        hora_salida_tolera: "",
        hora_retorno_tolera: ""
      },
      valid: false,
      loading: false,
      id_detalle: -1
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerDetalle", async item => {
      (this.form = {
        cite: item.cite,
        objetivo: item.objetivo,
        fecha_salida: item.fecha_desde,
        fecha_retorno: item.fecha_hasta,
        hora_salida: item.hora_salida,
        hora_retorno: item.hora_llegada,
        hora_salida_tolera: this.restaHoras(item.hora_salida, 2),
        hora_retorno_tolera: this.sumaHoras(item.hora_llegada, 2),
        ci: item.ci
      }),
        (this.dialog = true);
    });
  },
  methods: {
    sumaHoras(horas, suma) {
      let cadena = horas.split(":");
      let hora = parseInt(cadena[0]) + suma;
      if ((hora + "").length == 1) {
        hora = "0" + hora;
      }
      return hora + ":" + cadena[1];
    },
    restaHoras(horas, suma) {
      let cadena = horas.split(":");
      let hora = parseInt(cadena[0]) - suma;
      if ((hora + "").length == 1) {
        hora = "0" + hora;
      }
      return hora + ":" + cadena[1];
    },
    async cargarForm() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			query{
				runQuery(consulta:"SELECT id,id_persona,cite, objetivo,fecha_salida,fecha_retorno,hora_salida_viaje,hora_retorno_viaje,hora_salida_tolera,hora_retorno_tolera FROM CONTROL.comision WHERE id=4"){
					respuesta
				}
				}
			`
        });
        respuesta = respuesta.runQuery.respuesta[0];
        this.form = respuesta;
      } catch (error) {}
    },
    close() {
      this.form = {
        cite: "",
        objetivo: "",
        fecha_salida: "",
        fecha_retorno: "",
        hora_salida: "",
        hora_retorno: "",
        hora_salida_tolera: "",
        hora_retorno_tolera: ""
      };
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        // control.fn_registra_comision_viaje(
        // 	p_cite character varying,
        // 	p_objetivo text,
        // 	p_fecha_salida date,
        // 	p_fecha_retorno date,
        // 	p_hora_salida character varying,
        // 	p_hora_retorno character varying,
        // 	p_ci_funcionario character varying)
        let respuesta;
		let resps
        let consulta = `SELECT CONTROL.fn_registra_comision_viaje('${this.form.cite}','${this.form.objetivo}','${this.form.fecha_salida}','${this.form.fecha_retorno}','${this.form.hora_salida}','${this.form.hora_retorno}','${this.form.ci}')`;
        try {
          respuesta = await this.$service.graphql({
            query: `
				query{
				runQuery(consulta:"${consulta}"){
					respuesta
				}
				}
			`
          });
          respuesta= respuesta.runQuery.respuesta[0].fn_registra_comision_viaje;
          resps = respuesta.split("|");
          correcto = resps[0];
          if (correcto === "1") {
            this.$confirm("Registro exitoso", () => {});
          } else {
            this.$confirm(resps[1], () => {});
          }
        } catch (error) {
          console.log(error);
        }
		this.$message.success("Registro exitoso")
        this.loading = true;
        this.loading = false;
        this.close();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/comision_viaje/dialogs/VerDetalle.vue